import React from "react";
import PropTypes from "prop-types";
import { User } from "lucide-react";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return `${date.getFullYear()}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}`;
};

const ReportField = ({ label, value }) => (
  <div className="flex flex-col border-b border-slate-100 pb-2 last:border-0 last:pb-0">
    <span className="text-[10px] text-slate-400 uppercase font-bold tracking-wider mb-1">
      {label}
    </span>
    <span className="text-sm font-medium text-slate-600">{value || "N/A"}</span>
  </div>
);

const PersonalDetailsCard = ({ applicant }) => {
  const personalDetails = [
    {
      label: "Gender",
      value: applicant?.gender
        ? applicant.gender.charAt(0).toUpperCase() + applicant.gender.slice(1)
        : "",
    },
    { label: "Date of Birth", value: formatDate(applicant?.date_of_birth) },
    { label: "State", value: applicant?.state },
    { label: "Home Address", value: applicant?.contact_address },
  ];

  return (
    <div className="bg-white rounded-xl  border border-slate-200 overflow-hidden w-full">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <User size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Personal Details
        </h2>
      </div>
      <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
        {personalDetails.map((detail, index) => (
          <ReportField key={index} label={detail.label} value={detail.value} />
        ))}
      </div>
    </div>
  );
};

PersonalDetailsCard.propTypes = {
  applicant: PropTypes.shape({
    gender: PropTypes.string,
    date_of_birth: PropTypes.string,
    contact_address: PropTypes.string,
    state: PropTypes.string,
  }),
};

export default PersonalDetailsCard;
